import {
  sortTree,
  getTreeWithChangedFolderName,
} from '../components/media-hub/utils';

export const FOLDER_FETCH = 'FOLDER/FETCH';
export const FOLDER_FETCH_SUCCESS = 'FOLDER/FETCH_SUCCESS';
export const FOLDER_FETCH_FAILURE = 'FOLDER/FETCH_FAILURE';
export const FOLDER_SET_CURRENT = 'FOLDER/SET_CURRENT';
export const FOLDER_SET_EDITED = 'FOLDER/SET_EDITED';
export const FOLDER_ADD = 'FOLDER/ADD';
export const FOLDER_ADD_FAILURE = 'FOLDER/ADD_FAILURE';
export const FOLDER_TOGGLE_TREE = 'FOLDER/TOGGLE_TREE';
export const FOLDER_DELETE_SUCCESS = 'FOLDER/DELETE_SUCCESS';
export const FOLDER_DELETE_FAILURE = 'FOLDER/DELETE_FAILURE';
export const FOLDER_DELETE = 'FOLDER/FOLDER_DELETE';
export const FOLDER_EDIT = 'FOLDER/EDIT';
export const FOLDER_EDIT_SUCCESS = 'FOLDER/EDIT_SUCCESS';
export const FOLDER_EDIT_FAILURE = 'FOLDER/EDIT_FAILURE';

const initialState = {
  tree: {},
  currentDirectory: null,
  treeOpen: true,
};

export const fetchFolders = () => ({
  type: FOLDER_FETCH,
});

export const folderDelete = id => ({
  payload: {
    id: id,
  },
  type: FOLDER_DELETE,
});

export const folderEdit = (id, payload) => ({
  id,
  payload,
  type: FOLDER_EDIT,
});

export const addFolder = folder => ({
  type: FOLDER_ADD,
  payload: { folder },
});

export const setCurrentFolder = folderId => ({
  type: FOLDER_SET_CURRENT,
  payload: folderId,
});

export const setEditedFolder = folderId => ({
  type: FOLDER_SET_EDITED,
  payload: folderId,
});

export const toggleTree = () => ({
  type: FOLDER_TOGGLE_TREE,
});

export const folderReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FOLDER_SET_CURRENT: {
      return { ...state, currentDirectory: payload };
    }
    case FOLDER_SET_EDITED: {
      return { ...state };
    }
    case FOLDER_FETCH_SUCCESS: {
      sortTree(payload);
      return { ...state, tree: payload };
    }
    case FOLDER_DELETE_SUCCESS: {
      return { ...state, tree: payload };
    }
    case FOLDER_EDIT_SUCCESS: {
      const folderName = payload.payload.folder.name;
      const newTree =
        getTreeWithChangedFolderName(state.tree, payload.id, folderName) ||
        state.tree;
      return { ...state, tree: { ...newTree } };
    }
    case FOLDER_TOGGLE_TREE: {
      const { treeOpen } = state;
      return { ...state, treeOpen: !treeOpen };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/folder.reducer.js